import { render, staticRenderFns } from "./RemplacementsInput.vue?vue&type=template&id=d44a3766"
import script from "./RemplacementsInput.vue?vue&type=script&lang=ts"
export * from "./RemplacementsInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports